<template>
    <div>
        <kt-button v-if="
        request_details.status == posStatuses.ACTIVE ||
        request_details.status == posStatuses.PENDING ||
        request_details.status == posStatuses.CORRECTION ||
       (request_details.status == posStatuses.AGENCY_CHECK && $can('manage','pos'))"
                   class="m-2"
                   size="md"
                   @click="addParent"
                   variant="success"
                   type="submit"
                   v-bind:wide="true"
                   id="addParent"
        >
            {{ $t('btn.add') }}
        </kt-button>
        <div v-for="(parent, index) in form.parent" v-bind:key="index">
            <kt-form-section v-show="parent.show_child" :id="index">
                <div class="container p-3 pt-5 my-4 border in-border-header"
                     style="border: solid 2px #5e5e5e !important;">
                    <div class="section-header">
                        {{ $t('pos.stakeholder_detail') }}
                    </div>
                    <form v-if="parent.get_customer_form" @submit.prevent="getCustomer(index)"
                          :id="'get_customer_by_code'+index">
                        <div class="container p-3 pt-5 my-4 border in-border-header">
                            <kt-form-section is_first>
                                <div class="section-header">
                                    {{ $t('pos.get_stakeholder_owner_by_code') }}
                                </div>
                                <kt-row>
                                    <kt-col lg="3" md="3" xs="12">
                                        <kt-form-group>
                                            <kt-form-label for="customer_type">
                                                {{ $t('pos.customer_type') }}
                                            </kt-form-label>
                                            <select
                                                    id="customer_type_id"
                                                    class="form-control kt-selectpicker"
                                                    name="customer_type_id"
                                                    v-model="parent.customer_type_id"
                                            >
                                                <option
                                                        v-for="(user_type, index) in constants.customer_type"
                                                        :key="index"
                                                        :value="index"
                                                        v-show="index != customerType.MULTI_ACCOUNT_OWNER">
                                                    {{ user_type }}
                                                </option>
                                            </select>
                                            <div class="my-4">
                                            </div>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col v-if="parent.customer_type_id==customerType.LEGAL" id="legal_code" lg="6"
                                            md="6" xs="12">
                                        <kt-form-group>
                                            <kt-form-label for="company_code">
                                                {{ $t('label.national_legal_code') }} <span
                                                    style="color: red">{{ ' *' }}</span>
                                            </kt-form-label>
                                            <kt-form-control
                                                    type="number"
                                                    dir="ltr"
                                                    id="company_code"
                                                    name="company_code"
                                                    v-model="parent.company_code"
                                            >
                                            </kt-form-control>
                                        </kt-form-group>

                                    </kt-col>
                                    <kt-col id="national_code" v-if="parent.customer_type_id==customerType.REAL ||
                                                 parent.customer_type_id==customerType.MULTI_ACCOUNT_OWNER" lg="6"
                                            md="6" xs="12">
                                        <kt-form-group>
                                            <kt-form-label for="national_code">
                                                {{ $t('label.national_code') }} <span
                                                    style="color: red">{{ ' *' }}</span>
                                            </kt-form-label>
                                            <kt-form-control
                                                    type="national_code"
                                                    dir="ltr"
                                                    id="national_code"
                                                    name="national_code"
                                                    v-model="parent.national_code"
                                            >
                                            </kt-form-control>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col v-if="parent.customer_type_id == customerType.LEGAL || parent.customer_type_id==customerType.REAL ||
                                    parent.customer_type_id==customerType.MULTI_ACCOUNT_OWNER "
                                            lg="3" md="3" xs="6">
                                        <kt-form-action class="mt-4">
                                            <kt-button
                                                    class="m-2"
                                                    size="md"
                                                    variant="success"
                                                    type="submit"
                                                    v-bind:wide="true"
                                                    :id="'btn_inquiry'+index"
                                            >
                                                {{ $t('pos.btn_inquiry') }}
                                            </kt-button>
                                        </kt-form-action>
                                    </kt-col>
                                </kt-row>
                            </kt-form-section>
                        </div>
                    </form>
                    <div v-if="parent.show_detail" class="container p-3 pt-5 my-4 border in-border-header">
                        <form :id="'customer_detail'+index">
                            <kt-form-section is_first>
                                <div class="section-header">
                                    {{ $t('pos.account_owner_information') }}
                                </div>
                                <kt-row>
                                    <kt-col lg="4" md="6" xs="12">
                                        <kt-form-group>
                                            <kt-form-label
                                                    v-if="parent.customer_detail.customer_type_id == customerType.REAL||
                                    parent.customer_detail.customer_type_id == customerType.MULTI_ACCOUNT_OWNER"
                                                    for="national_code">
                                                {{ $t('label.national_code') }} <span
                                                    style="color: red">{{ ' *' }}</span>
                                            </kt-form-label>
                                            <kt-form-label
                                                    v-if="parent.customer_detail.customer_type_id == customerType.LEGAL"
                                                    for="national_code">
                                                {{ $t('pos.ceo_national_code') }} <span
                                                    style="color: red">{{ ' *' }}</span>
                                            </kt-form-label>
                                            <kt-form-control
                                                    :disabled="!parent.can_change"
                                                    type="number"
                                                    dir="ltr"
                                                    id="national_code"
                                                    name="national_code"
                                                    v-model="parent.customer_detail.national_code"
                                                    class="form-control"
                                            ></kt-form-control>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col v-show="!parent.is_foreign" lg="4" md="6" xs="12">
                                        <kt-form-group>
                                            <kt-form-label for="birth_crtfct_number">
                                                {{ $t('label.birth_crtfct_number') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                    type="number"
                                                    dir="ltr"
                                                    id="birth_crtfct_number"
                                                    name="birth_crtfct_number"
                                                    v-model="parent.customer_detail.birth_crtfct_number"
                                                    class="form-control"
                                            ></kt-form-control>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col v-show="!parent.is_foreign" lg="4" md="6" xs="12">
                                        <kt-form-group>
                                            <kt-form-label for="birth_crtfct_serial">
                                                {{ $t('label.birth_crtfct_serial') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                    type="number"
                                                    dir="ltr"
                                                    id="birth_crtfct_serial"
                                                    name="birth_crtfct_serial"
                                                    v-model="parent.customer_detail.birth_crtfct_serial"
                                                    class="form-control"
                                            ></kt-form-control>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col v-show="!parent.is_foreign" lg="4" md="6" xs="12">
                                        <kt-form-group>
                                            <kt-form-label for="birth_crtfct_series_number">
                                                {{ $t('label.birth_crtfct_series_number') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                    type="number"
                                                    dir="ltr"
                                                    id="birth_crtfct_series_number"
                                                    name="birth_crtfct_series_number"
                                                    v-model="parent.customer_detail.birth_crtfct_series_number"
                                                    class="form-control"
                                            ></kt-form-control>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col v-show="!parent.is_foreign" lg="4" md="6" xs="12">
                                        <kt-form-group>
                                            <kt-form-label for="birth_crtfct_number">
                                                {{ $t('label.birth_crtfct_series_letter') }}
                                            </kt-form-label>
                                            <select
                                                    id="birth_crtfct_series_letter"
                                                    name="birth_crtfct_series_letter"
                                                    v-model="parent.customer_detail.birth_crtfct_series_letter"
                                                    class="form-control kt-selectpicker"
                                            >
                                                <option
                                                        v-bind:key="birthCrtfctSeriesLetter.key"
                                                        v-for="birthCrtfctSeriesLetter in birthCrtfctSeriesLetters"
                                                        :value="birthCrtfctSeriesLetter.key"
                                                >
                                                    {{ birthCrtfctSeriesLetter.value }}
                                                </option>
                                            </select>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col lg="4" md="6" xs="12">
                                        <kt-form-group>
                                            <kt-form-label for="birth_date">
                                                {{ $t('label.birth_date') }}<span
                                                    v-if="parent.customer_detail.customer_type_id == customerType.REAL||
                                    parent.customer_detail.customer_type_id == customerType.MULTI_ACCOUNT_OWNER"
                                                    style="color: red">{{ ' *' }}</span>
                                            </kt-form-label>
                                            <datePicker
                                                    format="YYYY-MM-DD"
                                                    display-format="jDD jMMMM jYYYY"
                                                    input-class="form-control"
                                                    id="birth_date"
                                                    name="birth_date"
                                                    v-model="parent.customer_detail.birth_date" type="date"/>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col v-if="psp=='NOVIN'" lg="4" md="6" xs="12">
                                        <kt-form-group>
                                            <kt-form-label for="customer_id">
                                                {{ $t('pos.customer_id') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                    disabled
                                                    type="number"
                                                    dir="ltr"
                                                    id="customer_id"
                                                    name="customer_id"
                                                    v-model="parent.customer_detail.customer_id"
                                                    class="form-control"
                                            ></kt-form-control>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col lg="4" md="6" xs="12">
                                        <kt-form-group>
                                            <kt-form-label for="gender_id">
                                                {{ $t('label.gender') }}
                                            </kt-form-label>
                                            <select
                                                    id="gender_id"
                                                    name="gender_id"
                                                    v-model="parent.customer_detail.gender_id"
                                                    class="form-control kt-selectpicker"
                                            >
                                                <option
                                                        v-for="(item,index) in constants.gender"
                                                        :key="index"
                                                        :value="index">
                                                    {{ item }}
                                                </option>
                                            </select>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col lg="4" md="6" xs="12">
                                        <kt-form-group>
                                            <kt-form-label for="mobile">
                                                {{ $t('pos.mobile') }}<span
                                                    style="color: red">{{ ' *' }}</span>
                                            </kt-form-label>

                                            <kt-form-control
                                                    dir="ltr"
                                                    :disabled="parent.can_change"
                                                    :id="'mobile'+ index"
                                                    name="mobile"
                                                    v-model="parent.customer_detail.mobile"
                                                    class="form-control"
                                            ></kt-form-control>
                                            <kt-form-label style="margin-top: 5px;font-size: 9px;color: red">
                                                {{ $t('pos.mobile_notification') }}
                                            </kt-form-label>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col lg="4" md="6" xs="12">
                                        <kt-form-group>
                                            <kt-form-label for="first_name_fa">
                                                {{ $t('label.first_name_fa') }}
                                                <span style="color: red">{{ ' *' }}</span>
                                            </kt-form-label>
                                            <kt-form-control
                                                    id="first_name_fa"
                                                    name="first_name_fa"
                                                    v-model="parent.customer_detail.first_name_fa"
                                                    class="form-control"
                                            ></kt-form-control>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col lg="4" md="6" xs="12">
                                        <kt-form-group>
                                            <kt-form-label for="last_name_fa">
                                                {{ $t('label.last_name_fa') }} <span style="color: red">{{
                                                    ' *'
                                                }}</span>
                                            </kt-form-label>
                                            <kt-form-control
                                                    id="last_name_fa"
                                                    name="last_name_fa"
                                                    v-model="parent.customer_detail.last_name_fa"
                                                    class="form-control"
                                            ></kt-form-control>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col lg="4" md="6" xs="12">
                                        <kt-form-group>
                                            <kt-form-label for="father_name_fa">
                                                {{ $t('label.father_name_fa') }} <span style="color: red">{{
                                                    ' *'
                                                }}</span>
                                            </kt-form-label>
                                            <kt-form-control
                                                    id="father_name_fa"
                                                    name="father_name_fa"
                                                    v-model="parent.customer_detail.father_name_fa"
                                                    class="form-control"
                                            ></kt-form-control>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col lg="4" md="6" xs="12">
                                        <kt-form-group>
                                            <kt-form-label for="first_name_en">
                                                {{ $t('label.first_name_en') }}
                                                <span style="color: red">{{ ' *' }}</span>
                                            </kt-form-label>
                                            <kt-form-control
                                                    id="first_name_en"
                                                    name="first_name_en"
                                                    v-model="parent.customer_detail.first_name_en"
                                                    class="form-control"
                                            ></kt-form-control>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col lg="4" md="6" xs="12">
                                        <kt-form-group>
                                            <kt-form-label for="last_name_en">
                                                {{ $t('label.last_name_en') }} <span style="color: red">{{
                                                    ' *'
                                                }}</span>
                                            </kt-form-label>
                                            <kt-form-control
                                                    id="last_name_en"
                                                    name="last_name_en"
                                                    v-model="parent.customer_detail.last_name_en"
                                                    class="form-control"
                                            ></kt-form-control>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col lg="4" md="6" xs="12">
                                        <kt-form-group>
                                            <kt-form-label for="father_name_en">
                                                {{ $t('label.father_name_en') }} <span style="color: red">{{
                                                    ' *'
                                                }}</span>
                                            </kt-form-label>
                                            <kt-form-control
                                                    id="father_name_en"
                                                    name="father_name_en"
                                                    v-model="parent.customer_detail.father_name_en"
                                                    class="form-control"
                                            ></kt-form-control>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col v-show="parent.customer_detail.customer_type_id == customerType.LEGAL"
                                            lg="4" md="6"
                                            xs="12">
                                        <kt-form-group>
                                            <kt-form-label for="com_name_fa">
                                                {{ $t('label.com_name_fa') }} <span style="color: red">{{ ' *' }}</span>

                                            </kt-form-label>
                                            <kt-form-control
                                                    id="com_name_fa"
                                                    name="com_name_fa"
                                                    v-model="parent.customer_detail.com_name_fa"
                                                    class="form-control"
                                            ></kt-form-control>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col lg="4" md="6" xs="12"
                                            v-show="parent.customer_detail.customer_type_id == customerType.LEGAL">
                                        <kt-form-group>
                                            <kt-form-label for="register_number">
                                                {{ $t('label.com_register_date') }} <span
                                                    style="color: red">{{ ' *' }}</span>

                                            </kt-form-label>
                                            <datePicker
                                                    format="YYYY-MM-DD"
                                                    display-format="jDD jMMMM jYYYY"
                                                    input-class="form-control"
                                                    id="register_date"
                                                    name="register_date"
                                                    v-model="parent.customer_detail.register_date"
                                                    type="date"/>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col v-show="parent.customer_detail.customer_type_id == customerType.LEGAL"
                                            lg="4" md="6"
                                            xs="12">
                                        <kt-form-group>
                                            <kt-form-label for="register_number">
                                                {{ $t('pos.com_register_no') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                    type="number"
                                                    dir="ltr"
                                                    id="register_number"
                                                    name="register_number"
                                                    v-model="parent.customer_detail.register_number"
                                                    class="form-control"
                                            ></kt-form-control>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col v-show="parent.customer_detail.customer_type_id == customerType.LEGAL"
                                            lg="4" md="6"
                                            xs="12">
                                        <kt-form-group>
                                            <kt-form-label for="com_name_en">
                                                {{ $t('label.com_name_en') }} <span
                                                    style="color: red">{{ ' *' }}</span>
                                            </kt-form-label>
                                            <kt-form-control
                                                    id="com_name_en"
                                                    name="com_name_en"
                                                    v-model="parent.customer_detail.com_name_en"
                                                    class="form-control"
                                            ></kt-form-control>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col v-show="parent.customer_detail.customer_type_id == customerType.LEGAL"
                                            lg="4" md="6"
                                            xs="12">
                                        <kt-form-group>
                                            <kt-form-label for="company_code">
                                                {{ $t('label.national_legal_code') }} <span
                                                    style="color: red">{{ ' *' }}</span>
                                            </kt-form-label>
                                            <kt-form-control
                                                    disabled
                                                    type="number"
                                                    dir="ltr"
                                                    id="company_code"
                                                    name="company_code"
                                                    v-model="parent.customer_detail.company_code"
                                                    class="form-control"
                                            ></kt-form-control>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col v-show="parent.is_foreign" lg="4" md="6" xs="12">
                                        <kt-form-group>
                                            <kt-form-label for="country">
                                                {{ $t('label.country_flag') }}
                                            </kt-form-label>
                                            <select
                                                    id="country"
                                                    name="country"
                                                    v-model="parent.customer_detail.country"
                                                    class="form-control  kt-selectpicker"
                                            >
                                                <option
                                                        v-for="country in constants.country"
                                                        :key="country.CountryCode">
                                                    {{ country.CountryName }}
                                                </option>
                                            </select>
                                            <div class="my-4">
                                            </div>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col v-show="parent.is_foreign" lg="4" md="6" xs="12">
                                        <kt-form-group>
                                            <kt-form-label for="foreign_pervasive_code">
                                                {{ $t('pos.foreign_pervasive_code') }} <span
                                                    style="color: red">{{ ' *' }}</span>
                                            </kt-form-label>
                                            <kt-form-control
                                                    type="number"
                                                    dir="ltr"
                                                    id="foreign_pervasive_code"
                                                    name="foreign_pervasive_code"
                                                    v-model="parent.customer_detail.foreign_pervasive_code"
                                                    class="form-control"
                                            ></kt-form-control>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col v-show="parent.is_foreign" lg="4" md="6" xs="12">
                                        <kt-form-group>
                                            <kt-form-label for="passport_number">
                                                {{ $t('pos.passport_code') }}
                                                <span v-if="psp == 'NOVIN'" style="color: red">{{ ' *' }}</span>
                                            </kt-form-label>
                                            <kt-form-control
                                                    type="number"
                                                    dir="ltr"
                                                    id="passport_number"
                                                    name="passport_number"
                                                    v-model="parent.customer_detail.passport_number"
                                                    class="form-control"
                                            ></kt-form-control>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col v-show="parent.is_foreign" lg="4" md="6" xs="12">
                                        <kt-form-group>
                                            <kt-form-label for="passport_expire_date">
                                                {{ $t('pos.passport_credit_date') }} <span
                                                    style="color: red">{{ ' *' }}</span>
                                            </kt-form-label>
                                            <datePicker
                                                    format="YYYY-MM-DD"
                                                    display-format="jDD jMMMM jYYYY"
                                                    input-class="form-control"
                                                    id="passport_expire_date"
                                                    name="passport_expire_date"
                                                    v-model="parent.customer_detail.passport_expire_date"
                                                    type="date"/>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col v-if="parent.customer_detail.customer_type_id == customerType.REAL ||
                                    parent.customer_detail.customer_type_id == customerType.MULTI_ACCOUNT_OWNER" lg="12"
                                            md="12"
                                            xs="12">
                                        <kt-form-group>
                                            <div class="custom-control custom-switch">
                                                <input type="checkbox" class="custom-control-input"
                                                       :id="'is_foreign'+index"
                                                       name="is_foreign"
                                                       v-model="parent.is_foreign"
                                                >
                                                <label class="custom-control-label"
                                                       :for="'is_foreign'+index">{{
                                                        $t('pos.is_foreign')
                                                    }}</label>
                                            </div>
                                        </kt-form-group>
                                    </kt-col>
                                </kt-row>
                                <merchant-documents v-if="psp =='NOVIN'" :parent="parent"></merchant-documents>
                            </kt-form-section>
                        </form>
                    </div>
                    <div>
                        <form v-if="parent.show_detail" :id="'account_detail'+index">
                            <kt-form-section>
                                <div class="container p-3 pt-5 my-4 border in-border-header">
                                    <div class="section-header">
                                        {{ $t('pos.account_detail') }}
                                    </div>
                                    <kt-row style="padding-top: 35px">
                                        <kt-col lg="6" md="6" xs="12">
                                            <kt-form-group>
                                                <kt-form-label for="bank_id">
                                                    {{ $t('pos.bank') }}
                                                </kt-form-label>
                                                <select
                                                        id="bank_id"
                                                        name="bank_id"
                                                        v-model="parent.bank_id"
                                                        class="form-control kt-selectpicker"
                                                >
                                                    <option
                                                            v-for="bank in constants.banks"
                                                            :key="bank.BankID">
                                                        {{ bank.BankName }}
                                                    </option>
                                                </select>
                                            </kt-form-group>
                                        </kt-col>
                                        <kt-col lg="6" md="6" xs="12">
                                            <kt-form-group>
                                                <kt-form-label for="branch_code">
                                                    {{ $t('pos.branch_code') }}
                                                </kt-form-label>
                                                <kt-form-control
                                                        dir="ltr"
                                                        type="number"
                                                        id="branch_code"
                                                        name="branch_code"
                                                        v-model="parent.branch_code"
                                                        class="form-control"
                                                ></kt-form-control>
                                            </kt-form-group>
                                        </kt-col>
                                    </kt-row>
                                    <kt-row>
                                        <kt-col lg="6" md="6" xs="12">
                                            <kt-form-group>
                                                <kt-form-label for="account_number">
                                                    {{ $t('label.account_number') }}
                                                </kt-form-label>
                                                <kt-form-control
                                                        dir="ltr"
                                                        id="account_number"
                                                        name="account_number"
                                                        v-model="parent.account_number"
                                                        class="form-control"
                                                ></kt-form-control>
                                            </kt-form-group>
                                        </kt-col>
                                        <kt-col lg="6" md="6" xs="12">
                                            <kt-form-group>
                                                <kt-form-label for="sheba_number">
                                                    {{ $t('label.sheba_number') }}
                                                </kt-form-label>
                                                <kt-form-label for="sheba_number">
                                                    <div class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                                        <span class="tooltip-text">{{ $t('pos.btn_inquiry') }}</span>
                                                        <i @click="ibanInquiry(index)" class="fa fa-sync"
                                                           style="font-size: 14px;color: #1dc9b7; "></i>
                                                    </div>
                                                </kt-form-label>
                                                <kt-form-control
                                                        style="direction: ltr"
                                                        id="sheba_number"
                                                        name="sheba_number"
                                                        v-model="parent.sheba_number"
                                                        class="form-control transfers_destination_number"
                                                ></kt-form-control>
                                            </kt-form-group>
                                        </kt-col>
                                    </kt-row>
                                    <kt-row>
                                        <kt-col lg="6" md="6" xs="12">
                                            <kt-form-group>
                                                <kt-form-label for="sharing_percent">
                                                    {{ $t('allotment.percent') }}
                                                </kt-form-label>
                                                <kt-form-control
                                                        type="number"
                                                        dir="ltr"
                                                        id="sharing_percent"
                                                        name="sharing_percent"
                                                        v-model="parent.sharing_percent"
                                                        class="form-control"
                                                ></kt-form-control>
                                            </kt-form-group>
                                        </kt-col>
                                        <kt-col v-if="psp=='NOVIN'" lg="6" md="6" xs="12">
                                            <kt-form-group>
                                                <kt-form-label for="customer_id">
                                                    {{ $t('pos.customer_id') }}
                                                </kt-form-label>
                                                <kt-form-control
                                                        disabled
                                                        type="number"
                                                        dir="ltr"
                                                        id="customer_id"
                                                        name="customer_id"
                                                        v-model="parent.customer_id"
                                                        class="form-control"
                                                ></kt-form-control>
                                            </kt-form-group>
                                        </kt-col>
                                    </kt-row>
                                </div>

                            </kt-form-section>
                        </form>
                    </div>
                    <kt-button
                            class="m-2"
                            size="md"
                            dir="ltr"
                            @click="remove(index)"
                            variant="danger"
                            type="delete"
                            v-bind:wide="true"
                            id="remove"
                    >
                        {{ $t('btn.delete') }}
                    </kt-button>
                    <kt-button v-if="parent.show_detail" style="position: relative;right:75%"
                               class="m-2"
                               size="md"
                               dir="rtl"
                               @click="setAccount(index)"
                               variant="success"
                               type="submit"
                               v-bind:wide="true"
                               :id="'setAccount'+index"
                    >
                        {{ $t('btn.register') }}
                    </kt-button>
                    <kt-col lg="2" md="2" xs="4">
                        <kt-form-action style=" display: none;">
                            <kt-button
                                    data-toggle="modal" :data-target="'#iban_inquiry'+index"
                                    variant="success"
                                    type="submit"
                                    :id="'iban_inquiry_fire'+index"
                            >
                            </kt-button>
                        </kt-form-action>
                    </kt-col>
                    <div :id="'iban_inquiry'+index" class="modal fade rtl" role="dialog">
                        <div class="modal-dialog">

                            <!-- Modal content-->
                            <div class="modal-content">
                                <div class="modal-header">
                                    <div id="iban_inquiry_title">{{ $t('pos.iban_inquiry_title') }}</div>
                                    <div v-if="iban_inquiry.status == false" style=" padding-right: 20%"
                                         id="iban_inquiry_incorrect">
                            <span style="background-color:#fd397a"> {{
                                    $t('pos.message.iban_inquiry_incorrect')
                                }}</span></div>
                                    <div v-if="iban_inquiry.status == true" style=" padding-right: 20%"
                                         id="iban_inquiry_correct">
                            <span style="background-color:#1dc9b7">   {{
                                    $t('pos.message.iban_inquiry_correct')
                                }}</span></div>
                                    <button type="button" class="close float-right mr-0" data-dismiss="modal">&times;
                                    </button>
                                </div>
                                <div id="data_sheet" class="modal-body mb-4">
                                    <table class="table table-hover">
                                        <thead>
                                        <tr>
                                            <th class="table-info" colspan="2">
                                                {{ $t('pos.account_owner_fullname') + ' :' }}
                                            </th>
                                            <th class="table-info" colspan="2">{{
                                                    iban_inquiry.account_owner_name
                                                }}
                                            </th>
                                        </tr>
                                        <tr>
                                            <th class="table-info" colspan="2">{{ $t('pos.bank') + ' :' }}</th>
                                            <th class="table-info" colspan="2">{{ iban_inquiry.bank }}</th>
                                        </tr>
                                        <tr>
                                            <th class="table-info" colspan="2">{{ $t('pos.customer_code') + ' :' }}</th>
                                            <th class="table-info" colspan="2">{{ iban_inquiry.identifier }}</th>
                                        </tr>
                                        </thead>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </kt-form-section>
        </div>
    </div>
</template>
<script>
import $ from 'jquery'
import {i18n} from '@/plugins/i18n'
import Inputmask from "inputmask";
import {KTApp} from '@/plugins/core/app'
import {posService} from '@/common/api.service'
import {mapGetters} from "vuex";
import {customerType, gender} from '@/constants/posNovin'
import {posStatuses} from '@/constants/PosStatus'
import toastr from "toastr";
import {birthCrtfctSeriesLetters} from '@/constants/birthCrtfctSeriesLetter'
import merchantDocuments from "../documents/mechant-documents"
import IranSheba from "iran-sheba";

export default {
    name: "multi-account",
    components: {
        merchantDocuments
    },
    data() {
        return {
            birthCrtfctSeriesLetters,
            form: {
                parent: [],
            },
            customer_detail: {},
            show_detail: false,
            customerType,
            gender,
            posStatuses,
            iban_inquiry: {}
        }
    },
    props: {
        wizard: {
            type: Object
        },
        request_details: {
            type: Object
        },
        multi_accounts: Array,
        reloadDataTable: Function

    },
    methods: {
        addParent: function () {
            this.form.parent.push({
                bank_id: '',
                branch_code: '',
                account_number: '',
                sheba_number: '',
                sharing_percent: '',
                customer_id: '',
                customer_type: '',
                customer_code: '',
                customer_detail: '',
                show_detail: false,
                show_child: true,
                is_foreign: false,
                get_customer_form: true,
                images_url: {
                    national_card_img: null,
                    birth_certificate_card_img: null,
                    national_card_behind_img: null,
                    last_newspaper_img: null,
                    statute_pages_img: null,
                    foundation_img: null,
                    passport_img: null,
                    amayesh_card_img: null,
                    work_permit_img: null,
                },
                national_card_img: '',
                birth_certificate_card_img: '',
                national_card_behind_img: '',
                last_newspaper_img: '',
                statute_pages_img: [],
                foundation_img: '',
                passport_img: '',
                amayesh_card_img: '',
                work_permit_img: '',

            });
            this.afterDispatch()
            setTimeout(() => {
                this.initShebaMask()
            }, 500)
        },
        remove: function (index) {
            this.form.parent.splice(index, 1)
        },
        setAccount(index) {
            let form = $('#customer_detail' + index)
            let btn = $('#setAccount' + index)
            form.validate({
                lang: 'fa',
                rules: {
                    birth_date: {
                        required: true,
                    },
                    company_code: {
                        required: () => {
                            if (this.form.parent[index].customer_detail.customer_type_id == this.customerType.LEGAL) return true; else return false
                        }
                    },

                    register_number: {
                        required: () => {
                            if (this.form.parent[index].customer_detail.customer_type_id == this.customerType.LEGAL) return true; else return false
                        }
                    },
                    register_date: {
                        required: () => {
                            if (this.form.parent[index].customer_detail.customer_type_id == this.customerType.LEGAL) return true; else return false
                        }
                    },
                    passport_expire_date: {
                        required: () => {
                            if (this.form.parent[index].is_foreign) return true; else return false
                        }
                    },

                    com_name_fa: {
                        required: () => {
                            if (this.form.parent[index].customer_detail.customer_type_id == this.customerType.LEGAL) return true; else return false
                        }
                    },
                    com_name_en: {
                        required: () => {
                            if (this.form.parent[index].customer_detail.customer_type_id == this.customerType.LEGAL) return true; else return false
                        }
                    },
                    customer_type_id: {
                        required: true
                    },

                    gender_id: {
                        required: true,
                    },
                    last_name_fa: {
                        required: true
                    },

                    father_name_fa: {
                        required: true,
                    },
                    first_name_fa: {
                        required: true
                    },
                    last_name_en: {
                        required: true
                    },

                    father_name_en: {
                        required: true,
                    },
                    first_name_en: {
                        required: true
                    },
                    foreign_pervasive_code: {
                        required: () => {
                            if (this.form.parent[index].is_foreign) return true; else return false
                        }
                    },
                    passport_number: {
                        required: () => {
                            if (this.form.parent[index].is_foreign) return true; else return false
                        }
                    },
                    country: {
                        required: () => {
                            if (this.form.parent[index].is_foreign) return true; else return false
                        }
                    },
                    mobile: {
                        required: true,
                        digits: 11
                    },

                    national_code: {
                        required: true,
                    },
                }
            });
            if (!form.valid()) {
                return
            }
            let form1 = $('#account_detail' + index)
            form1.validate({
                lang: 'fa',
                rules: {
                    bank_id: {
                        required: () => {
                            if (this.psp == 'NOVIN') return true;
                        }
                    },
                    branch_code: {
                        required: true
                    },
                    account_number: {
                        required: true,
                    },
                    sheba_number: {
                        required: true,
                    },
                    sharing_percent: {
                        required: true,
                        max: 100,
                        min: 0
                    },
                }
            });
            if (!form1.valid()) {
                return
            }
            let sheba = this.form.parent[index].sheba_number.split('_').join('')
            sheba = sheba.split('-').join('')
            sheba = sheba.split(' ').join('')
            this.form.parent[index].sheba_number = sheba
            if (sheba.length != 26) return this.toastr.error(i18n.t('pos.message.invalid_sheba_format'))

            KTApp.progress(btn)

            this.form.parent[index].customer_detail.is_foreign_nationals = this.form.parent[index].is_foreign;

            let stakeholder = structuredClone(this.form.parent[index]);
            delete stakeholder.images_url;
            delete stakeholder.show_detail;
            delete stakeholder.show_child;
            delete stakeholder.is_foreign;
            delete stakeholder.get_customer_form;
            delete stakeholder.index;
            delete stakeholder.IsActive;
            delete stakeholder.customer_detail;

            let request_id = this.request_details.id;
            let stakeholder_data = {
                ...this.form.parent[index].customer_detail, ...stakeholder, request_id, psp: this.psp
            }
            for (let key in stakeholder_data) {
                if (stakeholder_data[key] == null) {
                    stakeholder_data[key] = ''
                }
            }
            posService.addStakeholder(stakeholder_data).then(response => {
                this.reloadDataTable()
                this.form.parent[index].show_child = false
                this.toastr.success(response.data.message)
            }).catch(({response}) => {
                this.toastr.error(response.data.message)
            }).finally(() => {
                KTApp.unprogress(btn)
            })

        },
        initShebaMask() {
            setTimeout(() => {
                Inputmask("IR 9999-9999-9999-9999-9999-9999")
                        .mask(document.querySelectorAll('.transfers_destination_number'))
            }, 500)
        }
        ,
        processFile(e, index) {
            const name = e.target.name;
            let file = e.target.files[0];
            this.form.parent[index].images_url[name] = URL.createObjectURL(file);
            this.form.parent[index][name] = file;
        },
        processStatuteFile(e, index) {
            this.form.parent[index].images_url.statute_pages_img = []
            for (let i = 0; i < e.target.files.length; i++) {
                let file = e.target.files[i];
                this.form.parent[index].images_url.statute_pages_img[i] = URL.createObjectURL(file);
                this.form.parent[index].statute_pages_img[i] = file;
            }
        },
        initMobileMask(index) {
            setTimeout(() => {
                document.getElementById('mobile' + index) && Inputmask('09999999999')
                        .mask(document.getElementById('mobile' + index))
            }, 500)
        }
        ,
        getCustomer(index) {
            let form = $('#get_customer_by_code' + index)
            let btn = $('#btn_inquiry' + index)
            this.form.parent[index].show_detail = false
            form.validate({
                lang: 'fa',
                rules: {
                    customer_type_id: {
                        required: true
                    },
                    national_code: {
                        required: () => {
                            if (this.form.parent[index].customer_type_id == this.customerType.REAL ||
                                    this.form.parent[index].customer_type_id == this.customerType.MULTI_ACCOUNT_OWNER) return true;
                        },
                        digits: true,
                        minlength: 10,
                        maxlength: 10
                    },
                    company_code: {
                        required: () => {
                            if (this.form.parent[index].customer_type_id == this.customerType.LEGAL) return true; else return false;
                        },
                        digits: true,
                        minlength: 11,
                        maxlength: 11
                    },
                }
            });
            if (!form.valid()) {
                return
            }
            let multi_account = this.multi_accounts
            let multi_acc_index = multi_account.length
            if ((this.request_details.customer_detail.customer_type_id === this.customerType.REAL ||
                            this.request_details.customer_detail.customer_type_id === this.customerType.MULTI_ACCOUNT_OWNER)&&
                    this.form.parent[index].national_code === this.request_details.customer_detail.national_code ||
                    this.request_details.customer_detail.customer_type_id === this.customerType.LEGAL &&
                    this.form.parent[index].company_code === this.request_details.customer_detail.company_code) {
                return this.toastr.error(i18n.t('message.duplicate_customer_code'))
            }
            if (multi_acc_index > 0) {
                for (let i = 0; i < multi_acc_index; i++) {
                    if ((this.form.parent[index].customer_type_id == this.customerType.REAL||
                                    this.form.parent[index].customer_type_id == this.customerType.MULTI_ACCOUNT_OWNER )&&
                            this.form.parent[index].national_code == multi_account[i].customer_detail.national_code) {
                        return this.toastr.error(i18n.t('message.duplicate_customer_code'))
                    } else if (this.form.parent[index].customer_type_id == this.customerType.LEGAL &&
                            this.form.parent[index].company_code == multi_account[i].customer_detail.company_code) {
                        return this.toastr.error(i18n.t('message.duplicate_customer_code'))
                    }
                }
            }
            this.form.parent[index].customer_detail = {}
            this.form.parent[index].is_foreign = false
            KTApp.progress(btn)
            let form_data = {
                customer_type_id: this.form.parent[index].customer_type_id,
                company_code: this.form.parent[index].company_code,
                national_code: this.form.parent[index].national_code,
                psp: this.psp
            };
            posService.getCustomerByCode(form_data).then(response => {
                if (response.data.data) {
                    this.form.parent[index].customer_detail = response.data.data
                    this.form.parent[index].customer_id = response.data.data.customer_id
                    if (!this.form.parent[index].customer_detail.gender_id) this.form.parent[index].customer_detail.gender_id = gender.MALE
                    if (this.form.parent[index].customer_detail.is_foreign_nationals == true) {
                        this.form.parent[index].is_foreign = true;
                    } else this.form.parent[index].is_foreign = false
                    if (this.form.parent[index].customer_detail.customer_id == '') this.form.parent[index].customer_detail.show_register_btn = true
                    if (this.$can('manage', 'pos')) {
                        this.form.parent[index].can_change = true
                    } else this.form.parent[index].can_change = false
                } else {
                    this.form.parent[index].can_change = true
                    this.form.parent[index].customer_detail.show_register_btn = true
                    this.form.parent[index].is_foreign = false
                    if (this.form.parent[index].customer_type_id == this.customerType.LEGAL) {
                        this.form.parent[index].customer_detail.customer_type_id = this.customerType.LEGAL
                        this.form.parent[index].customer_detail.company_code = this.form.parent[index].company_code
                    } else {
                        this.form.parent[index].customer_detail.customer_type_id = this.form.parent[index].customer_type_id
                        this.form.parent[index].customer_detail.national_code = this.form.parent[index].national_code
                    }
                    this.showMsg(form, 'danger', response.data.message)
                }
                this.form.parent[index].show_detail = true
                this.form.parent[index].get_customer_form = false
                KTApp.unprogress(btn)
                this.afterDispatch()
                this.initMobileMask(index)
                this.initShebaMask()
            }).catch(({response}) => {
                if (response.data) {
                    form.validate().showErrors(response.data.data)
                    KTApp.unprogress(btn)
                }

            })
        }
        ,
        afterDispatch() {
            setTimeout(() => {
                $('.kt-selectpicker').selectpicker({
                    size: 6,
                    liveSearch: false,
                    noneResultsText: i18n.t('selectpicker.none_result'),
                    selectAllText: i18n.t('selectpicker.select_all'),
                    noneSelectedText: i18n.t('selectpicker.nothing_chose')
                });
            }, 500);
        },
        ibanInquiry(index) {
            let sheba = this.form.parent[index].sheba_number
            sheba = sheba.split('-').join('')
            sheba = sheba.split(' ').join('')
            sheba = sheba.split('_').join('')
            this.form.parent[index].sheba_number = sheba
            if (sheba.length != 26) return this.toastr.error(i18n.t('pos.message.invalid_sheba_format'))

            let params = {
                identifier: (this.form.parent[index].customer_detail.customer_type_id == customerType.REAL ||
                        this.form.parent[index].customer_detail.customer_type_id == customerType.MULTI_ACCOUNT_OWNER )?
                        this.form.parent[index].customer_detail.national_code : this.form.parent[index].customer_detail.company_code,
                sheba_number: this.form.parent[index].sheba_number
            }
            posService.ibanInquiry(params).then(response => {
                this.iban_inquiry = {
                    status: response.data.data.status,
                    account_owner_name: this.form_data.customer_detail.first_name_fa + ' ' +
                            this.form_data.customer_detail.last_name_fa,
                    identifier: params.identifier,
                    bank: IranSheba.recognize(params.sheba_number)['persianName']
                }
                document.getElementById("iban_inquiry_fire" + index).click();
            }).catch(({response}) => {
                return this.toastr.error(response.data.message)
            })
        },
    },

    mounted() {
        this.afterDispatch()
        this.initShebaMask();
    },
    computed: {
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }
            return toastr
        },
        ...mapGetters('pos', [
            'psp', 'constants'
        ])
    },
}
</script>

<style>
#app {
    text-align: right;
    color: #2c3e50;
    margin-top: 60px;
}

a,
button {
    color: #4fc08d;
}

button {
    background: none;
    border: solid 1px;
    border-radius: 2em;
    padding: 0.75em 2em;
}

.form-repeater {
    line-height: 20px;
    margin-bottom: 20px;
}

.form {
    padding: 20px;
    border: 1px solid #000;
    border-radius: 20px;
}
</style>